import React, { Component } from 'react'
import './style.css'

class ConversationsWithRudy extends Component {
  render () {
    return (
      <div className='convos-with-rudy-page-container'>
        <div className='convos-with-rudy-main-container'>
          <div className='available-titles-info-div-rudy'>
            <p className='available-titles-rudy-alt-name'>Conversations with Rudy Burckhardt About Everything</p>
            <h3 className='rudy-author-name'>by Simon Pettet</h3>
            <div className='rudy-images-div'>
              <div className='rudy-not-dynamic-div'>
                <div className='rudy-conversations-link-3'>
                  <img src='https://i.imgur.com/5HcMQD4.jpg' className='convo-with-rudy-img-alt' alt='' />
                  <img src='https://i.imgur.com/4u9QGOK.jpg' className='convo-with-rudy-2-img-alt' alt='' />
                </div>
                  <p className='rudy-photos-description1'>Rudy Burckhadt</p>
                  <p className='rudy-photos-description2'>Photo by Timothy Greenfield-Sanders</p>
                  <h3 className='rudy-price'>$20 per copy</h3>
                  <p className='rudy-text-1'>ISBN 0-931428-20-3</p>
                  <p className='rudy-text'>10 x 8 inches</p>
                  <p className='rudy-text'>72 pages</p>
              </div>
            </div>
          </div>
          <div className='buy-now-div3'>
            <form action='https://www.paypal.com/cgi-bin/webscr' method='post' target='_blank'>
              <input type='hidden' name='cmd' value='_s-xclick' />
              <input type='hidden' name='hosted_button_id' value='84LRLJWJBYE3S' />
              <input type='image' className='paypal-button' img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/buy-logo-large.png" alt="Buy now with PayPal" name='submit' />
            </form>
          </div>
          <p className='rudy-text-body-1'>Available for purchase from <a href='FIX' className='ilylali-link' target='_blank'>movingvehicle@gmail.com</a> Printed in duotone offset in an edition of 2,000 copes by The Studley Press, Dalton, Massachusetts. 22 photographs included. Text stock is Warren Lustro Dull and endpapers are Curtis Flannel. Text type is Frutiger. Edition is smyth sewn. </p>
          <p className='rudy-text-body'>
          Conversations with Rudy Burckhardt includes an extensive interview with Simon Pettet and 22 photographs
          in duotone by the noted photographer, filmmaker and painter Rudy Burckhardt. The photographs, taken
          between 1930 and 1986, include his classic, much-admired image of the Flatiron Building, New York 1948,
          and photographs of rhapsodic beauty in Maine, gentle serenity in Naples, many humorous scenes
          (New York, Little Rock, Florence, etc.) and others. His images are all completely accessible and
          reflect his resolutely unpretentious style. The sprightly dialogue complements the photographs, with
          many discussed individually.
          </p>
          <p className='rudy-text-body'>
          Rudy Burckhardt is, according to John Ashbery, “a subterranean monument.” Born in Basel, Switzerland
          in 1914, he came to New York City when he was 21. He soon established himself as a photographer and,
          in addition to his own photographic art, made a significant contribution documenting work for major
          galleries and art publications. His previous book, a memoir entitled Mobile Homes, was published by
          Z Press in1979, and photographs have been included in numerous volumes over the years, including
          the Complete Poems of Edwin Denby published by Random House in 1986. He died in August 1999 and is
          survived by his wife Yvonne Jacquette, his ex-wife Edith Schloss, his two sons Jacob and Tom Burckhardt
          and two grandsons.
          </p>
          <p className='rudy-text-body'>
          Simon Pettet is a British poet living in New York City and is the author of several books
          (most recently, Hearth (Talisman, 2009)
          </p>
          <p className='rudy-text-body'>
          The publication of Conversations with Rudy Burckhardt in 1987 honored the occasion of three significant
          events in New York City. After decades of relative obscurity, Rudy Burckhardt¹s devoted underground
          following was joined by many newfound admirers as a result of a major retrospective of 67 of his films
          at the Museum of Modern Art, and, concurrently, an exhibition of photographs at Brooke Alexander Gallery
          and a show of paintings at Blue Mountain Gallery.
          </p>
          <p className='rudy-text-body'>
          As Phillip Lopate has remarked, “In the book, one is privileged to hear the artist¹s thoughts and
          doubts about living, making art, beauty, time, youth, aging, public acclaim, compositional techniques,
          Switzerland, parents, and the non-relationship between rapture and sorrow … The combination of beautiful,
          rarely-seen photographs and lively text make this an irresistible book.”
          </p>
          <p className='rudy-last-p rudy-text-body'>
          Rudy Burckhardt was a New York photographer, filmmaker and painter, whose work is currently enjoying
          great attention, with a Museum of Modern Art retrospective, and two shows at the Brooke Alexander and
          Blue Mountain galleries. These conversations with the poet Simon Pettet were held in New York City.
          They illuminate Burckhardt’s esthetic but also the general climate and philosophy of the New York School,
          particularly the part of it that included both artists and writers. Since the late 1950s painters and
          poets in New York have enjoyed the sort of friendships that define the entire atmosphere of an era.
          Among the most celebrated are the poet Frank O’Hara’s close ties to Jackson Pollock and Franz Kline,
          the poet Ted Berrigan’s intimacy with Joe Brainard and Alex Katz, and many others. Not coincidentally,
          this lovely book is dedicated to Edwin Denby, the late great New York poet and dance critic. “It’s true,”
          says Denby, “there is such a thing as real beauty, only it’s only a second that you see it. I mean,
          real beauty, in the sense of a fact. You look up and say ‘Oh’ and then it’s gone, because something
          else has happened….It isn’t an artifice, it’s just the way things are…. And Rudy sees so many of them.”
          Judging by the many photographs in this exquisitely made little book, Rudy Burckhardt certainly does.
          He sees something else too: the outlandish humor in the everyday. He is also remarkably free of the
          art-pretentious drivel one reads in the art magazines. “Haven’t you always had to deal with being
          underestimated?” Simon Pettet asks him.” I was never aware of that,” says Burckhardt, and he goes on
          to explain, “That’s a fiction…. Because, supposing a beautiful girl gives me a big smile. That’s enough.
          That can make my day. She’s not ‘underestimating.’ I don’t really feel the worth of achievement.
          You know, achieve a body of work and people have to admire it. That’s phony actually.” Rudy Burckhardt
          is anything but. What he is, is an artist, all the time, even when he talks.
          </p>
        </div>
      </div>
    )
  }
}

export default ConversationsWithRudy
